export default {
  loadingAccounting: false,
  detailAccounting: "",
  accountingCountDocuemnts: 0,
  paramsAccounting: {
    branchoffice_id: "",
    model_id: "",
    filterDate: []
  }
};



// WEBPACK FOOTER //
// ./src/modules/accounting-inventory-movements/state.js